import { useEffect, useState } from 'react';
import '../App.scss';
import { Button } from '@mui/base/Button';
import { TextField, FormControlLabel, Switch, } from '@mui/material';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import { AdminClient, CompanyModel } from '../types';
import { createClient } from "../api/clients";

function EditCompany() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [name, setName] = useState('');
  const [projectLimit, setProjectLimit] = useState(0);
  const [isEnabled, setIsEnabled] = useState(true);

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const adminClient = createClient(AdminClient);

  useEffect(() => {
    const loadCompany = async () => {
      if (!id) {
        setErrorMessage('No user id provided.');
        setLoading(false);
        return;
      }

      setErrorMessage(null);
      setLoading(true);

      try {
        const result: CompanyModel = await adminClient.getCompany(id);

        setName(result.name ?? "");
        setIsEnabled(result.isEnabled ?? true);
        setProjectLimit(result.projectLimit ?? 0);

        setLoading(false);
      } catch (error) {
        console.error('Error loading company:', error);
        setErrorMessage('Unable to load company details. Please try again.');
        setLoading(false);
      }
    };

    loadCompany();
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage(null);

    if (!id) {
      setErrorMessage('No company id provided.');
      return;
    }

    const company: CompanyModel = { id, name, isEnabled, projectLimit};

    try {
      const result = await adminClient.updateCompany(company);

      if (result.success === false) {
        setErrorMessage(result.error ?? null);
        return;
      }

     navigate(`/admin`, { replace: true });
    } catch (error) {
      console.error('Error updating company:', error);
      setErrorMessage('Something went wrong. Please try again.');
    }
  };

  if (loading) {
    return (
      <div className="main pb-4 d-flex flex-column align-items-center">
        <h4 className="mb-6">Edit company</h4>
        <p>Loading company details…</p>
      </div>
    );
  }

  return (
    <div className="main pb-4 d-flex flex-column align-items-center">
      <Button
        className="styled-button mb-4"
        onClick={() => navigate('/admin')}
      >
        ← Back
      </Button>

      <h4 className="mb-6">Edit Company</h4>

      <form onSubmit={handleSubmit} className="d-flex flex-column align-items-center">
        <TextField
          id="name"
          label="Name"
          variant="outlined"
          className="mb-4"
          style={{ minWidth: '300px' }}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

         <TextField
          id="prohectLimit"
          label="Project Limit"
          variant="outlined"
          type="number"
          className="mb-4"
          style={{ minWidth: '300px' }}
          value={projectLimit}
          onChange={(e) => setProjectLimit(Number(e.target.value))}
          required
        />

        <FormControlLabel
          control={
            <Switch
              id = "enable-company"
              checked={isEnabled}
              onChange={(e) => setIsEnabled(e.target.checked)}
              color="primary"
            />
          }
          label="Enabled"
          className="mb-4"
        />
        {errorMessage && (
          <div className="form-error mb-3">
            {errorMessage}
          </div>
        )}

        <Button type="submit" className="styled-button mb-4" id="btn-edit-company">
          Update company
        </Button>
      </form>
    </div>
  );
}

export default EditCompany;
